import { useEffect, useState } from "react";

const AnimatedSummaryText = ({ summary }) => {
  const [displayed, setDisplayed] = useState([]);
  const [index, setIndex] = useState(0);
  const [parts, setParts] = useState([]);

  useEffect(() => {
    if (!summary) return;

    const tokens = summary.split(/(\s+|\.)/g).filter((t) => t.trim() !== "");
    setParts(tokens);
    setIndex(0);
    setDisplayed([]);
  }, [summary]);

  useEffect(() => {
    if (index >= parts.length) return;

    const current = parts[index];
    const delay = current === "." ? 850 : 270;

    const timer = setTimeout(() => {
      setDisplayed((prev) => [...prev, current]);
      setIndex((prev) => prev + 1);
    }, delay);

    return () => clearTimeout(timer);
  }, [index, parts]);

  return (
    <div className="text-xl text-center max-w-2xl leading-relaxed font-light text-white">
      {displayed.map((word, i) => (
        <span
          key={i}
          className="inline-block opacity-0 animate-fade-in-fast mx-[2px]"
          style={{ animationDelay: `${i * 0.04}s` }}
        >
          {word}
        </span>
      ))}

      <style jsx>{`
        @keyframes fadeInFast {
          from {
            opacity: 0;
            transform: translateY(8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-in-fast {
          animation: fadeInFast 0.4s ease forwards;
        }
      `}</style>
    </div>
  );
};

export default AnimatedSummaryText;
